<template>
  <div
    v-if="store.isUpdateReady"
    class="pwa-update"
    role="status"
  >
    <span class="pwa-update__text">{{ t("pwa.updateReady") }}</span>

    <div class="pwa-update__actions">
      <button
        type="button"
        class="pwa-update__button pwa-update__button--primary"
        @click="apply"
      >
        {{ t("pwa.updateApply") }}
      </button>
      <button
        type="button"
        class="pwa-update__button"
        @click="store.isUpdateReady = false"
      >
        {{ t("pwa.updateLater") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { usePwaStore } from "../store/pwa";
import { applyPwaUpdate } from "../common/composables/usePwa";

const { t } = useI18n();
const store = usePwaStore();

function apply(): void {
  applyPwaUpdate();
}
</script>
